import React from 'react';
import cx from 'classnames';
import styles from './Nav.module.scss';
import type { NavProps } from './Nav.types';

const Nav = (props: NavProps) => {
  const {
    className,
    children,
    ...restProps
  } = props;
  return (
    <nav
      {...restProps} 
      className={cx(styles.nav, className)}
    >
      <ul className={styles.navItems}>
        {children}
      </ul>
    </nav>
  );
};
export default Nav;
